export default __webpack_public_path__ + "static/media/product41.34258af1.png";